import { all, select, call, put } from 'redux-saga/effects';
import axios from 'axios';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { getProfileOwner } from '../../selectors/users';
import { API_BASE_PATH } from '../../../constants';
import { PapiPostsRequestParams } from '../../../types/papi';
import { PostsType } from '../../../types/posts';
import { biFetchMoreFolderItems } from '../../actions/bi';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags/selectors';
import { initializeThread } from '@wix/da-shared-react/pkg/CommentThread/actionCreators';
import { getCommentableTypeForDeviationType } from '@wix/da-shared-react/pkg/DeviationPage/redux/helpers';
import {
  FEED_COMMENTS_ITEMS_PER_FETCH,
  FEED_COMMENTS_MAX_DEPTH,
} from '../../streams/posts';

function fetchFromApi(postsType, params) {
  return axios
    .get(`${API_BASE_PATH}/module/${postsType}`, { params })
    .catch(response => false);
}

export default function* fetchMorePosts(action) {
  const { streamId } = action;

  yield put(biFetchMoreFolderItems(streamId));
  const [offset, limit, streamParams, profileOwner = {}] = yield all([
    select(state => withOffset.selectors.getNextOffset(state, streamId)),
    select(state => streamSelectors.getItemsPerFetch(state, streamId)),
    select(state => streamSelectors.getStreamParamsSafe(state, streamId)),
    select(getProfileOwner),
  ]);

  const queryParams: PapiPostsRequestParams = {
    username: profileOwner.user && profileOwner.user.username,
    moduleid: streamParams.moduleId,
    order: streamParams.sortOrder,
    filter: streamParams.filter,
    offset,
    limit,
  };

  const postsType: PostsType = streamParams.postsType;

  if (postsType === PostsType.JOURNALS) {
    queryParams.expand = 'deviation.fulltext';
  }

  const response = yield call(fetchFromApi, postsType, queryParams);
  if (!response || response.status !== 200) {
    yield put(withOffset.actions.fetchFailure({ streamId }));
    // TODO error catching
    return;
  }

  const { hasMore, total, nextOffset, results } = response.data;
  const { result, entities } = normalize(results, [deviationSchema]);

  yield put(
    withOffset.actions.fetchSuccess({
      streamId,
      hasMore,
      nextOffset,
      items: result,
      total,
      entities,
    })
  );

  if (postsType === PostsType.JOURNALS) {
    const postfeed_longer_comment_pages = yield select(
      flagEnabled,
      'postfeed_longer_comment_pages'
    );
    const commentThreads = results.map(deviation =>
      put(
        initializeThread({
          thread: {
            commentableItemId: deviation.deviationId,
            commentableTypeId: getCommentableTypeForDeviationType(
              deviation.typeId
            ),
            items: [],
            hasMore: !!deviation.stats?.comments,
            total: deviation.stats?.comments ?? 0,
            canPostComment: !!deviation.isCommentable,
          },
          maxDepth: FEED_COMMENTS_MAX_DEPTH,
          ...(postfeed_longer_comment_pages && {
            itemsPerFetch: FEED_COMMENTS_ITEMS_PER_FETCH,
          }),
        })
      )
    );
    yield all(commentThreads);
  }
}
